var map = {
	"./ar.png": "b493",
	"./bsc.png": "57aa",
	"./cfx.png": "8030",
	"./default.svg": "f02f",
	"./eth.png": "4d9b",
	"./moon.png": "abe1",
	"./platon.png": "6bec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d5cc";